import type { IdentificationAuthMode } from '@src/domains/customers';

export const IDENTIFICATION_ORIGIN = {
  accountCheck: 'account-check',
  buyerChoice: 'buyer-choice',
} as const;

export type IdentificationOrigin = (typeof IDENTIFICATION_ORIGIN)[keyof typeof IDENTIFICATION_ORIGIN];

export type EmailIdentificationPayload = {
  email: string;
  mode: IdentificationAuthMode;
  origin: IdentificationOrigin;
};
